import { createInjectionKey as e } from "./highrise529.mjs";
const t = e("n-internal-select-menu"), o = e("n-internal-select-menu-body");
export {
  o as internalSelectionMenuBodyInjectionKey,
  t as internalSelectionMenuInjectionKey
};
